ko.extenders.localStore = function (target, option)
{
    let key,
        isNumeric = false,
        canBeEmpty = true,
        observableKey = null,
        exclude = [];

    if (typeof option == 'string') {
        key = option;
    } else {

        isNumeric = option.isNumeric ?? isNumeric;
        canBeEmpty = option.canBeEmpty ?? canBeEmpty;
        exclude = option.exclude ?? exclude;

        if ('observableKey' in option) {
            key = ko.unwrap(option.observableKey);

            option.observableKey.subscribe(function (value)
            {
                key = value;

                value = localStorage.getItem(key);
                if (typeof value != 'undefined' && value != 'undefined' && value != '' && value != null) {
                    target(JSON.parse(value));
                }
            })
        } else {
            key = option.key;
        }

    }
    try {
        var value = localStorage.getItem(key);
        if (typeof value != 'undefined' && value !== 'undefined' && value !== '' && value !== null) {
            target(JSON.parse(value));
        }
    } catch (err) { console.warn(err) }

    target.subscribe(function (value)
    {
        if (!canBeEmpty && (value === undefined || value === '')) { return; }
        if (!canBeEmpty && isNumeric && (value === undefined || value === '' || value === 0 || value === '0')) { return; }
        if (isNumeric && isNaN(value)) { return; }



        if (!exclude || !exclude.includes(value)) {
            localStorage.setItem(key, JSON.stringify(value));
        }

    });

    //window.addEventListener('storage', onStorageEvent, false);



    target.restore = function ()
    {
        var value = localStorage.getItem(key);
        if (typeof value != 'undefined' && value != 'undefined' && value != '' && value != null) {
            target(JSON.parse(value));
        }

    }
    return target;
}
